export const CLEAR_APPROVALS = 'CLEAR_APPROVALS';
export const APPROVALS_EVALUATE_ITEM = 'APPROVALS_EVALUATE_ITEM';
